import IPaginatedParams from '@models/paginated-params';
import { getCountries } from '@services/countryServices';
import { useQuery } from '@tanstack/react-query';

export const useCountries = (limit: number, page: number, query: string) => {
  const enabled = query.length > 2;
  const params: IPaginatedParams = { limit, page, query };
  return useQuery({
    queryKey: ['countries', limit, page, query],
    queryFn: () => getCountries(params),
    enabled,
    refetchOnWindowFocus: false,
  });
};
